import axios from "axios"

export const getArticle = (id) => {
  return axios.get(`/api/intranet/v1/articles/${id}`)
}

export const getArticleFromSlug = (slug) => {
  return axios.get(`/api/intranet/v1/articles/slug/${slug}`)
}
